import Select from '@/components/DSE/Select';
import Switch from '@/components/DSE/Switch';
import Cascader from '@/components/DSE/Cascader';
import { validatorRequire } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    priceListItemID: {
      type: Select,
      props: {
        caption: 'linkPriceListItem.priceListItem',
        valueField: 'id',
        labelField: 'description',
        loading: vue.$store.getters['priceListItem/isLoading'],
        options: vue.$store.getters['priceListItem/loadedItems'],
        required: true
      },
      rules: [{ validator: validatorRequire }]
    },
    selectedFinishes: {
      type: Cascader,
      props: {
        caption: 'linkPriceListItem.selectedFinishes',
        optionsFunction: vue.getFinishTypeCascader,
        multiple: true
      }
    },
    blackoutYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'linkPriceListItem.blackoutYN'
      }
    },
    extraCostYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'linkPriceListItem.extraCostYN'
      }
    },
    veloursYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'productType.velours'
      }
    }
  };
}

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
